import { useState } from 'react'

const useCheckAutoFill = () => {
   const [hasAutoFill, setHasAutoFill] = useState<boolean>(false)

   const onAnimationStart = (e: any) => {
      try {
         const hasAutofill = !!e.target?.matches('*:autofill')
         setHasAutoFill(hasAutofill)
      } catch (e) {
         console.error('Error in useCheckAutoFill', e)
      }
   }

   return { hasAutoFill, onAnimationStart }
}

export default useCheckAutoFill
